export default __webpack_public_path__ + "static/33-e9809ddbf553382ebaf9914d266b122b.png";